import { render, staticRenderFns } from "./BaseCardIndicator.vue?vue&type=template&id=064e4c14&scoped=true&"
import script from "./BaseCardIndicator.vue?vue&type=script&lang=js&"
export * from "./BaseCardIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardIndicator.vue?vue&type=style&index=0&id=064e4c14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e4c14",
  null
  
)

export default component.exports